import React, { useEffect, useState } from "react";
import "./SlideMenu.scss";
import { SlideMenuButton } from "./SlideMenuButton/SlideMenuButton";
import { useTranslation } from "react-i18next";
import { slideContent } from "../OverlaySlides/OverlaySlides";
import { useOverlaySubject } from "../../../hooks/useOverlaySubject";

interface IProps {

}

export function SlideMenu(props: IProps) {
    const { t, i18n } = useTranslation();
    const { subject, setSubject } = useOverlaySubject();
    const { language } = i18n;
    const slides = slideContent[language];
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setOpen(false);
        }, 500);
        return () => {
            clearTimeout(timeout);
        }
    }, [subject]);

    useEffect(() => {
        if (!open) return;
        const closeTimeout = setTimeout(() => {
            setOpen(false);
        }, 20 * 1000);
        return () => {
            clearTimeout(closeTimeout);
        }
    }, [open]);

    const items = slides.map((slide, index) => {
        return <li key={index}>
            <button className={subject === slide.key ? 'active' : ''} onClick={() => setSubject(slide.key)}>
                <svg id="Component_2_70" data-name="Component 2 – 70" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                    <circle id="Ellipse_9" data-name="Ellipse 9" cx="25" cy="25" r="25" fill="#fff" opacity="0"/>
                    <g id="Group_49" data-name="Group 49" transform="translate(349.683 -967.778) rotate(-45)">
                        <rect id="Rectangle_271" data-name="Rectangle 271" width="16" height="4" rx="2" transform="translate(-941 475)" fill="#208fcb"/>
                        <rect id="Rectangle_272" data-name="Rectangle 272" width="4" height="16" rx="2" transform="translate(-929 463)" fill="#208fcb"/>
                    </g>
                </svg>
                {slide.altTitle ?? slide.title}
            </button>
        </li>
    })


    return (
        <>
            <div className={`slide-menu-wrapper ${open ? 'open' : 'closed'}`}>
                <SlideMenuButton open={open} onClick={() => setOpen(!open)} />
                <div className="slide-menu-inner">
                    <h5>{t('menu.make-a-choice')}</h5>
                    <div className="slide-menu-container">
                        <ul>{items}</ul>
                    </div>
                </div>
            </div>
        </>

    )
}
